import Popup from './popup';
import Tracker from '../../helpers/tracker';
import { TrackingData } from '../../helpers/TrackingTypes';
import { DeviceManager, MOBILE, TABLET } from '../DeviceManager';

const ZoomGalleryPopup = Popup.extend({
	constructor(opts) {
		opts = opts || {};

		this.gallery = opts.productImagesSlider;

		this.trackingCategory = opts.trackingCategory;

		this.deviceManager = new DeviceManager();

		this.isMobile = this.deviceManager.getCurrentState() === MOBILE;

		this.isTablet = this.deviceManager.getCurrentState() === TABLET;

		this.config = {
			opener: '.zoom-image',
			iconOpener: '.zoom-image-icon',
			productImageRoot: '.product',
			mobileOpener: '.js-slider-tile-item.active',
			popupContent: '#zoom',
			content: '.modal-content',
			popup: '.modal-window',
			overlay: '.modal-window-overlay',
			closeBtn: '.modal-window .close-btn',
			className: 'zoom',
			pdpGallery: '.js-gallery-slider-holder',
			switchSlide: '.switch-slide',
			nextButton: '.js-next-slide-button',
			prevButton: '.js-prev-slide-button',
			zoomGallery: '.zoom-gallery',
			zoomImage: '.zoom-gallery img',
		};

		// todo start: remove this once all PDP will use portrait images. SHOTZ-458
		const isPortraitImage = jQuery(this.config.opener).parents('.main-image-portrait').length > 0;

		if (isPortraitImage) {
			this.config.className = 'zoom zoom-portrait-image';
		}
		// todo end

		this.initialSetData();

		this.init();

		this.attachEvents();

		this.popupContent = jQuery(jQuery(this.config.popupContent).html());
	},

	initialSetData() {
		this.zoomConfig = {
			isZoomActive: false,
			scaleMin: 1,
			scaleMax: this.isMobile ? 2 : 1.5,
		};

		this.positionConfig = {
			startPoint: {
				x: 0,
				y: 0,
			},
			nextPoint: {
				x: 0,
				y: 0,
			},
			endPoint: {
				x: 0,
				y: 0,
			},
			imagePosition: {
				x: 0,
				y: 0,
			},
		};
	},

	attachEvents() {
		jQuery(document).on('click', this.isMobile ? this.config.mobileOpener : this.config.opener, (e) => {
			e.preventDefault();
			const el = e.currentTarget;

			this.openZoomPopup(el);
		});

		// Allow the zoom icon to be position outside the image container
		jQuery(document).on('click', this.config.iconOpener, (e) => {
			e.preventDefault();
			const el = jQuery(e.currentTarget).closest(this.config.productImageRoot).find(this.config.opener);

			this.openZoomPopup(el);
		});

		if (this.gallery) {
			jQuery(document).on('click', this.config.nextButton, () => {
				this.nextSlide();
			});
			jQuery(document).on('click', this.config.prevButton, () => {
				this.prevSlide();
			});
		}

		jQuery(document).on('mousedown gesturestart touchstart', this.config.zoomGallery, (e) => {
			jQuery(this.config.zoomImage).on('dragstart selectstart', (e) => {
				e.preventDefault();
			});

			this.setEventCoordinates(e, this.positionConfig.startPoint);

			if (e.type === 'mousedown') {
				this.onMouseDown();
			}
		});

		jQuery(window).on('resize', () => this.calculateSnapBorder());

		this.subscribe('popup:closed', () => {
			this.zoomReset();

			jQuery(this.popup).removeClass('visible');
		});
	},

	setEventCoordinates(e, positionConfig) {
		if (this.isMobile || this.isTablet) {
			if (e.type === 'touchmove' || e.type === 'touchstart') {
				positionConfig.x = e.targetTouches[0].clientX;

				positionConfig.y = e.targetTouches[0].clientY;
			} else if (e.type === 'touchend') {
				positionConfig.x = e.changedTouches[0].clientX;

				positionConfig.y = e.changedTouches[0].clientY;
			}
		} else {
			positionConfig.x = e.clientX;

			positionConfig.y = e.clientY;
		}
	},

	onMouseDown() {
		if (!this.zoomConfig.isZoomActive) {
			this.zoomConfig.isZoomActive = true;

			jQuery(this.config.zoomGallery).addClass('active');

			this.applyImageTransform(this.zoomConfig.scaleMax);

			this.calculateSnapBorder();
		} else {
			this.attachZoomEvents();

			document.querySelector(this.config.zoomGallery).classList.add('move');
		}
	},

	applyImageTransform(scale) {
		document.querySelector(
			this.config.zoomImage
		).style.transform = `translate(${this.positionConfig.imagePosition.x}px, ${this.positionConfig.imagePosition.y}px) scale(${scale})`;
	},

	calculateSnapBorder() {
		const imageHolder = jQuery(this.config.zoomGallery);
		const imageHolderWidth = imageHolder.width();
		const imageHolderHeight = imageHolder.height();
		const verticalPosition = (imageHolderHeight * this.zoomConfig.scaleMax - imageHolderHeight) / 2;
		const horizontalPosition = (imageHolderWidth * this.zoomConfig.scaleMax - imageHolderWidth) / 2;

		this.snapBorderPosition = {
			topBorder: verticalPosition,
			bottomBorder: -verticalPosition,
			leftBorder: horizontalPosition,
			rightBorder: -horizontalPosition,
		};
	},

	attachZoomEvents() {
		jQuery(document).on('mousemove gesturechange touchmove', this.config.zoomGallery, (e) => {
			this.setEventCoordinates(e, this.positionConfig.nextPoint);

			this.onMouseMove();
		});

		jQuery(document).on('mouseup mouseleave touchend gestureend', this.config.zoomGallery, (e) => {
			this.setEventCoordinates(e, this.positionConfig.nextPoint);

			if (e.type === 'mouseup' || e.type === 'mouseleave') {
				this.onMouseUp();
			}
		});
	},

	onMouseMove() {
		this.setImagePosition();

		this.applyImageTransform(this.zoomConfig.scaleMax);
	},

	setImagePosition() {
		this.positionConfig.imagePosition.x =
			this.positionConfig.endPoint.x + this.positionConfig.nextPoint.x - this.positionConfig.startPoint.x;

		this.positionConfig.imagePosition.y =
			this.positionConfig.endPoint.y + this.positionConfig.nextPoint.y - this.positionConfig.startPoint.y;
	},

	onMouseUp() {
		if (
			this.positionConfig.nextPoint.x === this.positionConfig.startPoint.x &&
			this.positionConfig.nextPoint.x === this.positionConfig.startPoint.x
		) {
			this.zoomReset();

			return;
		}

		this.detachZoomEvents();

		jQuery(this.config.zoomGallery).removeClass('move');

		this.snapImageToBorder();

		this.positionConfig.endPoint.x = this.positionConfig.imagePosition.x;

		this.positionConfig.endPoint.y = this.positionConfig.imagePosition.y;
	},

	zoomReset() {
		this.initialSetData();

		this.applyImageTransform(this.zoomConfig.scaleMin);

		jQuery(this.config.zoomGallery).removeClass('active move');

		this.detachZoomEvents();
	},

	detachZoomEvents() {
		jQuery(document).off('mousemove mouseleave mouseup dragstart selectstart', this.config.zoomGallery);
	},

	snapImageToBorder() {
		const imagePositionY = this.positionConfig.imagePosition.y;
		const imagePositionX = this.positionConfig.imagePosition.x;
		const top = this.snapBorderPosition.topBorder;
		const bottom = this.snapBorderPosition.bottomBorder;
		const left = this.snapBorderPosition.leftBorder;
		const right = this.snapBorderPosition.rightBorder;

		if (imagePositionY > top) {
			this.positionConfig.imagePosition.y = top;
		} else if (imagePositionY < bottom) {
			this.positionConfig.imagePosition.y = bottom;
		}

		if (imagePositionX > left) {
			this.positionConfig.imagePosition.x = left;
		} else if (imagePositionX < right) {
			this.positionConfig.imagePosition.x = right;
		}

		this.applyImageTransform(this.zoomConfig.scaleMax);
	},

	openZoomPopup(el) {
		let src = jQuery(el).find('img').attr('src');
		const img = this.popupContent.find('img');
		const fakeImage = jQuery(new Image());
		const imageSizeLarge = 'large';

		let imageSize = src.match(/small|medium/i);

		this.open(this.popupContent);

		fakeImage.on('load', () => {
			if (this.config.isPopupOpened) {
				jQuery(this.popup).addClass('visible');
			}
		});

		if (imageSize) {
			imageSize = imageSize[0];
			src = src.replace(imageSize, (match) => {
				// If matching `Small` or `Medium` we want to replace with `Large` (case-aware replace)
				if (match[0] === match[0].toUpperCase()) {
					return imageSizeLarge[0].toUpperCase() + imageSizeLarge.slice(1);
				} else {
					return imageSizeLarge;
				}
			});
		}

		fakeImage.attr('src', src);
		img.attr('src', src);

		Tracker.track({
			category: this.trackingCategory,
			action: TrackingData.ACTION_OPEN_ZOOM,
			label: src,
		});
	},

	changePopupImage() {
		const src = jQuery(this.config.opener).find('img').attr('src');
		const imagePopup = jQuery(this.config.content).find('img');

		imagePopup.attr('src', src.replace('Small', 'Large'));
	},

	nextSlide() {
		this.gallery.selectNextSlide();
		this.zoomReset();
		this.changePopupImage();
	},

	prevSlide() {
		this.gallery.selectPrevSlide();
		this.zoomReset();
		this.changePopupImage();
	},
});

export default ZoomGalleryPopup;
